
CheckoutV2.Cart.Shipping = function(checkout, cart) {
	var shipping = this;

	this.total = 0;
	this.originalShippingRetail = 0;

	this.country =
	this.original_country =
	this.zip =
    this.city =
	this.quoteRequest =
	this.$disabledMsg =
	this.errorMsg =
		false;

	this.zipRequired = true;

	//this.$wrap = $('#cart-shipping-wrap');
	this.$error = $('#cart-shipping-error'); //.js-cart-alerts .cart-error
	this.$errorMsg = this.$error.find('.msg-text');
	this.$errorClose = this.$error.find('.close');
	//this.$disabledOverlays = this.$wrap.find('.disabled-overlay');

	// this.$noShipping = $('#order-summary-no-shipping');
	// this.$noShippingMsg = this.$noShipping.find('.msg-text');
	// this.$noShippingClose = this.$noShipping.find('.close');
	
	this.$weight = $('.js-shipping-weight');
	this.$country = $('#cart-country');
	this.$zip = $('#cart-zip');
    this.$city = $('#cart-city');

    this.$salesZip     = $( ".sales-view #cart-zip" );
    this.$salesCountry = $( ".sales-view #cart-country" );
	
	this.$estimateShippingModal = $('#estimateShipping');
	this.$estimateShipping = $('.js-estimateShipping');

	this.init = function() { 
		var country = checkout.session.get('shipping.country'),
			original_country = checkout.session.get('shipping.country'),
			zip = checkout.session.get('shipping.zip'),
			billZip = checkout.session.get('billing.zip'),
			copyBilling = Boolean(checkout.session.get('copy_billing'));

		if (country)
			shipping.$country.val(country);

		if (zip) {
			if (copyBilling && billZip) { // if copyBilling use billing zip else shipping zip
				shipping.$zip.val(billZip);
				$('#billing_zip').attr('disabled', 'disabled'); // checkout.billship.$billing.zip is undefined???
			} else {
				shipping.$zip.val(zip);
				$('#billing_zip').removeAttr('disabled');
			}
		}
		shipping.updateEstimatedShippingLink();
		
		if (checkout.billship) {
			checkout.billship.checkMatchingZipCode();
		}

		// if (checkout.session.get('PayPalConfirmed'))
		//	shipping.disable(true);

		shipping.listen();
	};

	this.listen = function() {

		shipping.$country
			.change(function() {
				shipping.$zip.val('');
				//shipping.calc(false, true);
			})
			.focus(function() {
				shipping.removeFieldError(shipping.$country);
			});

		//shipping.$zip
		//	.bind('input propertychange', function() {
		//		checkout.delayChange(shipping.$zip, 1000, function() {
		//			shipping.calc(false, true);
		//		});
		//	})
		//	.focus(function() {
		//		shipping.removeFieldError(shipping.$zip);
		//	});	
		shipping.$zip.on('focus', function(){
			shipping.removeFieldError(shipping.$zip);
		});
		shipping.$zip.on('keyup keypress', function(e){
			var keyCode = e.keyCode || e.which;
			if (keyCode === 13) { 
				e.preventDefault();
				return false;
			}
		});
		
		shipping.$estimateShipping.on('click', function(){
			shipping.updateEstimatedShippingLink();
			shipping.calc(false, true);
			var errors = cart.shipping.getValidateErrors(false); // pass in false to skip shipQuote check, has not completed yet
			if (errors.length) {
				cart.shipping.showValidateErrors(errors);
			} else {
				shipping.$estimateShippingModal.modal('hide');
			}
		});

        shipping.$salesCountry.change( function() {
			shipping.calc(false, true);
        } );

        shipping.$salesZip.bind( "input propertychange", function() {
            checkout.delayChange( shipping.$salesZip, 1000, function() {
                shipping.calc(false, true);
            } );
        } );
		
		shipping.$errorClose.on('click', function(){
			shipping.error(false);
		});
		
		$('.checkout-v2').on('click', '#order-summary-no-shipping .close, #shipping-options-no-shipping .close', function(){
			shipping.noShipping(false);
		});
	};

	this.validateInput = function() {

		if (
			!Object.keys(cart.items).length
			|| !shipping.country
		)
			return false;

		if (!shipping.zipRequired)
			return true;

		if (
			!shipping.zip
			|| shipping.zip.length < 3
		)
			return false;

		return true;
	}

	this.calc = async function(force, destChanged, cb) {
		var $countryOption = shipping.$country.find('option:selected'),
			country = $countryOption.val() ? $countryOption.val().trim() : "",
			zip = shipping.$zip.val().trim(),
            city = shipping.$city.val().trim();
/*
			if(country == "US"){
				isDomestic = true;
				$("html").removeClass("intntl");
				$("#shipping-service-desc").hide();
			}
			else{
				isDomestic =  false;
				$("html").addClass("intntl");
				$("#shipping-service-desc").show();
			}
*/
		// no change
		if (
			!force
			&& country == shipping.country
			&& zip == shipping.zip
            && city == shipping.city
		)
			return cart.toggleStepControls();

		if (shipping.quoteRequest)
			shipping.quoteRequest.abort();

		// Ensures that the container has actually been "populated" when we start with no cookies/ session data on the page
		// NC-392
        if(!checkout.shipping){
            checkout.shipping = new CheckoutV2.Shipping(checkout);
            checkout.shipping.buildContent({});
        }

		var countryChanged = false;
		var usePoETA = false;
		if (shipping.country && country != shipping.country)  {
			countryChanged = true;
			usePoETA = ( country != 'US' );
		}
		shipping.country = country;
		shipping.zip = zip;
        shipping.city = city;
		shipping.zipRequired = Boolean(parseInt($countryOption.attr('data-ziprequired')));

		// no cart contents to quote on
		if (!shipping.validateInput()) {

			shipping.total = 0;
			checkout.shippingServiceGroupID = false;
			cart.totals.update('cart');

			shipping.error(false);
			shipping.noShipping(false);

			cart.toggleStepControls();

			return;
		}

		// Save this data in session
		checkout.session.set({
			'shipping': {
				'country': shipping.country,
				'zip': shipping.zip
			}
		});


		var update_shipping = () => {
            return new Promise( ( resolve, reject ) => {
                cart.totals.loading('Calculating Shipping');
                if (checkout.shipping)
                    checkout.shipping.loading("Calculating shipping");

                checkout.shippingServiceGroupID = checkout.session.get('shippingServiceGroupID') || false;
                checkout.shippingServiceGroupRates = {};
                checkout.shippingServiceCode = checkout.session.get('shippingServiceCode') || false;
                checkout.shippingRates = {};

                shipping.error(false);
                shipping.noShipping(false);

                // Hide step-control buttons while shipping is quoting
                cart.toggleStepControls(false);

                var wantQuoteType = (
                    checkout.session.get('shippingDisplayType')
                    || 'auto'
                );

                shipping.quoteRequest = checkout.remote.call({
                    'url': checkout.config.shipQuoteEndpoint,
                    'data': {
                        'wantQuoteType': wantQuoteType,
                        'shipping_country': shipping.country,
                        'shipping_zip': shipping.zip,
                        'shipping_address1': checkout.session.get('shipping.address1'),
                        'shipping_address2': checkout.session.get('shipping.address2'),
                        'shipping_city' : checkout.session.get('shipping.city'),
                        'country_name': shipping.getCountryName(),
                        'shipETA': checkout.cart.shipETA,
                        'po_shipETA': checkout.cart.po_shipETA,
                    }
                })
                    .done(function(response) {
                        shipping.handleShipQuoteResponse(response, destChanged)
                        if (cb)
                            cb();
                    })
                    .fail(function(request) {				
                        var errorMsg = checkout.remote.getErrorMsg(request);
                        
                        if (errorMsg)
                            shipping.error( true );
                        reject();
                    })
                    .always(function() {
                        if (checkout.shipinfo) 
                            checkout.shipinfo.displayShippingAddress( null,  usePoETA );
                        cart.totals.loading( false );
                        shipping.quoteRequest = false;
                        cart.toggleStepControls();
                        resolve();
                    });
            } );
		};

		try {
		    if (countryChanged) await checkout.cart.checkItems(true,false,usePoETA);
            await update_shipping();
        }
        catch ( e ) { console.warn( "failed ship quote", e ) }
	};
	
	this.handleShipQuoteResponse = function(response, destChanged) {
		checkout.$nextStep.prop('disabled', false);
		
		checkout.smartCartEligible = response.smartCartEligible || 0;
		if ('serviceGroupRates' in response) {
			checkout.shippingServiceGroupRates = response.serviceGroupRates;
		}
		else if ('rates' in response) {
			checkout.shippingRates = response.rates;
		}

		if ('couriers' in response)
			checkout.shippingCouriers = response.couriers;

		if ('services' in response)
			checkout.shippingServices = response.services;

		if ('map' in response)
			checkout.shippingMapURL = response.map;

		if ('multiLocations' in response)
			checkout.shippingMultiLocations = response.multiLocations;
			
		if ('prop65' in response){
			checkout.shippingProp65 = response.prop65;
		}

		if ('shippingRatesDetails' in response) {
			checkout.shippingRatesDetails = response.shippingRatesDetails;
		}

		if ('invalidShippingRates' in response) {
			checkout.invalidShippingRates = response.invalidShippingRates;
		}

        if ( response.carbRestricted ) {
            shipping.noShipping( true, `This order contains a product which cannot be shipped to the state of ${ response.carbLocality } as per adoption of CARB emissions regulations.` );
            checkout.$nextStep.prop('disabled', true);
            checkout.shippingServiceGroupID = false;
            checkout.shippingServiceCode = false;			
		    cart.totals.update('cart');
            checkout.onShippingQuoteResponse();
            return;
        }

		var serviceGroupRate;
		var rate;

		if (
			destChanged
		) {
			checkout.session.set({
				'shippingServiceGroupSet': 0,
				'shippingServiceSet': 0
			});
		}
		
		// Did we get no shipping options?
		if (response.rates &&
			response.rates.ERROR &&
			response.rates.ERROR.shippingCourierCode == "ERROR" &&
			response.rates.ERROR.shippingServiceCode == "ERROR") { 			
				shipping.noShipping(true);
				checkout.$nextStep.prop('disabled', true);
				checkout.shippingServiceGroupID = false;
				checkout.shippingServiceCode = false;			
		} else if (Object.keys(checkout.shippingServiceGroupRates).length > 0) {

			if (
				checkout.session.get('shippingServiceGroupSet')
				&& checkout.session.get('shippingServiceGroupID') in checkout.shippingServiceGroupRates
			) {
				serviceGroupRate = checkout.shippingServiceGroupRates[checkout.session.get('shippingServiceGroupID')];
			} else {
				serviceGroupRate = shipping.getCheapestGroupRate();
            }

			if (serviceGroupRate.shippingServiceGroupID == 'ERROR') {
				shipping.error( true );
                checkout.$nextStep.prop('disabled', true);
				checkout.shippingServiceGroupID = false;
			} else {
				checkout.shippingServiceGroupID = serviceGroupRate.shippingServiceGroupID;
			}

			shipping.total = (parseFloat(serviceGroupRate.price) || 0);
			shipping.originalShippingRetail = (parseFloat(serviceGroupRate.originalShippingRetail) || 0);

			if (!checkout.shipping)
				checkout.shipping = new CheckoutV2.Shipping(checkout);
			checkout.shipping.buildContent( response );
			
		} else if (Object.keys(checkout.shippingRates).length > 0) {

			if (
				checkout.session.get('shippingServiceSet')
				&& checkout.session.get('shippingServiceCode') in checkout.shippingRates
			) {
				rate = checkout.shippingRates[checkout.session.get('shippingServiceCode')];
			} else {
				rate = shipping.getCheapestRate();
			}

			if (rate.shippingServiceCode == 'ERROR') {
				shipping.error( true );
                checkout.$nextStep.prop('disabled', true);
				checkout.shippingServiceCode = false;
			} else {
				checkout.shippingServiceCode = rate.shippingServiceCode;
			}

			shipping.total = (parseFloat(rate.cost) || 0);
			shipping.originalShippingRetail = (parseFloat(rate.originalShippingRetail) || 0);

			if (!checkout.shipping)
				checkout.shipping = new CheckoutV2.Shipping(checkout);
			checkout.shipping.buildContent( response );

		}
		
		if ('weight' in response) {
			shipping.$weight.html((parseFloat(response.weight) || 0).toFixed(2) + ' lbs.');
        }

		if (response.taxValue) {
			cart.totals.taxValue = response.taxValue;
		} else {
			cart.totals.taxValue = 0;
		}

		cart.totals.update('cart');

		checkout.onShippingQuoteResponse();

	}

	this.getCountryName = function() {
		return shipping.$country.find('option:selected').html();
	};

	this.getCheapestGroupRate = function() {
		var cheapest = false;

		for (var shippingServiceGroupID in checkout.shippingServiceGroupRates) {
			var groupRate = checkout.shippingServiceGroupRates[shippingServiceGroupID];

			if (shippingServiceGroupID == 'ERROR')
				continue;

            if (groupRate.internalOnly)
                continue;

			if (groupRate.inStorePickup)
				continue;

			if (
				!cheapest
				|| parseFloat(groupRate.price) < parseFloat(cheapest.price)
			)
				cheapest = groupRate;
		}

		if (cheapest)
			return cheapest;

		if ('ERROR' in checkout.shippingServiceGroupRates)
			return checkout.shippingServiceGroupRates.ERROR;

		for (var shippingServiceGroupID in checkout.shippingServiceGroupRates)
			return checkout.shippingServiceGroupRates[shippingServiceGroupID];

		return false;
	};

	this.getCheapestRate = function(shippingCourierCode) {
		var cheapest = false;

		for (var shippingServiceCode in checkout.shippingRates) {
			var rate = checkout.shippingRates[shippingServiceCode],
				service = checkout.shippingServices[shippingServiceCode];

			if (shippingServiceCode == 'ERROR') {
				continue;
			}

			if ('internalOnly' in service) {
				continue;
			}

			if ('inStorePickup' in service) {
				continue;
			}

			if (
				shippingCourierCode
				&& rate.shippingCourierCode != shippingCourierCode
			) {
				continue;
			}

			if (
				!cheapest
				|| parseFloat(rate.cost) < parseFloat(cheapest.cost)
			) {
				cheapest = rate;
			}
		}

		if (cheapest) {
			return cheapest;
		}

		if ('ERROR' in checkout.shippingRates) {
			return checkout.shippingRates.ERROR;
		}

		for (var shippingServiceCode in checkout.shippingRates) {
			return checkout.shippingRates[shippingServiceCode];
		}

		return false;
	};

    this.inStorePickupSelected = function() {
        var selectedServiceGroup = checkout.shippingServiceGroupRates[checkout.shippingServiceGroupID]

        if (
            selectedServiceGroup
            && selectedServiceGroup['inStorePickup']
        ) {
            return true;
        }

        return false;
    }

	this.disable = function($disabledMsg) {
		shipping.$disabledMsg = $disabledMsg;
		shipping.$wrap.find('input,select').attr('disabled', 'disabled');
		shipping.$disabledOverlays.show();
	};

	this.enable = function() {
		shipping.$disabledMsg = false;
		shipping.$wrap.find('input,select').removeAttr('disabled');
		shipping.$disabledOverlays.hide();
		shipping.error(false);
		shipping.noShipping(false);
	};

	this.error = function( showError ) {
        var msg = false;
        if( showError ) msg = shipping.getSalesMessageText();

		if (msg) {
			shipping.$errorMsg.html(msg);
			shipping.$error.show();
		} else {
			shipping.$error.hide();
			shipping.$errorMsg.html('');
		}
		
	};

    this.getSalesMessageText = function() {
        var phone = checkout.config.contactInfo.phone;
        var extra = checkout.config.contactInfo.phoneExtra;
        var email = checkout.config.contactInfo.email;
        var chat  = checkout.config.contactInfo.liveChatHref;

        var phoneNumbersOnly = phone.replace( /\D/g, "" );
        var phoneLink = "+" + phoneNumbersOnly; 

        var msg  = "Please contact a sales associate to complete this order.<br />";
        msg     += "Email us at <a href='mailto:" + email + "'>" + email + "</a><br />";
        msg     += "Call us at <a href='tel:" + phoneLink + "'>" + phone + "</a>";
        if( extra ) {
            msg += ", " + extra;
        }
        msg     += "<br />";
        msg     += 'Or use our <a href="#" class="js-begin-chat">Live Chat</a>';

        return msg;
    };
	
	this.noShipping = function( showError, msg ) {
		var $noShipping = $('#order-summary-no-shipping, #shipping-options-no-shipping');
		var $noShippingMsg = $noShipping.find('.msg-text');
						
		if (showError) {
            if( ! msg ) msg = shipping.getNoShippingMessageText();
			$noShippingMsg.html(msg);
			$( "#shipping-loading-overlay" ).hide();
			
			if (checkout.step < 2) {
				$('#order-summary-no-shipping').show();
			} else {
				$('#shipping-options-no-shipping').show();
			}			
		} else {
			$noShipping.hide();
			$noShippingMsg.html('');
		}		
	};
	
	this.getNoShippingMessageText = function() {
        var phone = checkout.config.contactInfo.phone;
        var extra = checkout.config.contactInfo.phoneExtra;
        var email = checkout.config.contactInfo.email;
        var chat  = checkout.config.contactInfo.liveChatHref;

        var phoneNumbersOnly = phone.replace( /\D/g, "" );
        var phoneLink = "+" + phoneNumbersOnly; 

        var msg  = "There are no shipping options for this product to your location. ";
        msg     += "Please contact the " + checkout.config.siteName + " Sales department for further assistance.<br/><br/>"		
		msg     += "P: <a href='tel:" + phoneLink + "'>" + phone + "</a><br/>";
		msg     += "E: <a href='mailto:" + email + "'>" + email + "</a><br/>";        
        msg     += '<a href="#" onclick="' + chat + '">Live Chat</a>';

        return msg;
    };

	this.getValidateErrors = function(serviceCheck) {
		var serviceCheck = (typeof serviceCheck === 'undefined') ? true : serviceCheck; // true by default, need to bypass on estimate shipping button (only check country/zip)
		var errors = [];

		if (!Object.keys(cart.items).length) {
			errors.push({
				'msg' : 'Cart is Empty'
			});
		}

		if (!shipping.country) {
			errors.push({
				'field' : shipping.$country,
				'msg'   : 'Country is Required',
				'modal' : 1
			});
		}

		if (
			shipping.zipRequired
			&& !shipping.zip
		) {
			errors.push({
				'field' : shipping.$zip,
				'msg'   : 'Postal / Zip Code is Required',
				'modal' : 1
			});
		}

		if (errors.length)
			return errors;

		if (serviceCheck
			&& !checkout.shippingServiceGroupID
			&& !checkout.shippingServiceCode
		) {
			errors.push({
				'msg' : (shipping.errorMsg || 'Shipping Quote Failed')
			});
		}

		return errors;
	}

	this.showValidateErrors = function(errors) {
		var showModal = false;

		$.each(errors, function(i, error) {
			if (error.field) {
				shipping.fieldError(error.field, error.msg);
				if (error.modal) {
					showModal = true;
				}
			}
		});
		
		if (showModal) {
			shipping.$estimateShippingModal.modal('show');
		}

	}

	this.fieldError = function($field, errorMsg) {
		//$field.addClass('field-error');
		$('.js-' + $field[0].id + ' .invalid-feedback').html(errorMsg).show();
	};

	this.removeFieldError = function($field) {
		//$field.removeClass('field-error');
		$('.js-' + $field[0].id + ' .invalid-feedback').html('').hide();
	};
	
	this.updateEstimatedShippingLink = function() {
		if (shipping.$zip.val()) {
			$('.order-summary .shipping-link').text('(based on shipping to ' + shipping.$zip.val() + ')');
		} else {
			$('.order-summary .shipping-link').text('Estimate Shipping');
		}
	}
};
